import PropTypes from "prop-types";
import Link from "next/link";

const LinkContainer = ({children, ...props}) => (
  <Link style={{textDecoration: "none"}} {...props}>
    {children}
  </Link>
);

LinkContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

export default LinkContainer;
